import {
  authorizeDeleteRequest,
  authorizeGetRequest,
  authorizePatchRequest,
  authorizePostRequest,
  authorizePutRequest,
} from "api";
import { IApiResponse, IPaginatedResponse } from "models";
import {
  IFleetModel,
  IFleetModelInput,
  IUpdateFleetModelInput,
} from "models/fleetModel";

export const fleetModelsApi = (
  page: number,
  perPage: number,
  search: string
) => {
  return authorizeGetRequest<IPaginatedResponse<IFleetModel>>(
    `fleet-models?page=${page}&per_page=${perPage}&query=${search}`
  );
};

export const activeFleetModelsApi = () => {
  return authorizeGetRequest<IPaginatedResponse<IFleetModel>>(
    `fleet-models/driver-registration`
  );
};

export const banFleetModelApi = (id: string) => {
  return authorizePutRequest<IApiResponse<IFleetModel>>(
    `fleet-models/${id}/deactivate`,
    {}
  );
};

export const activateFleetModelApi = (id: string) => {
  return authorizePutRequest<IApiResponse<IFleetModel>>(
    `fleet-models/${id}/activate`,
    {}
  );
};

export const createFleetModelApi = (data: IFleetModelInput) => {
  return authorizePostRequest<IApiResponse<IFleetModel>>("fleet-models", data);
};

export const fetchFleetModelByIdApi = (id: string) => {
  return authorizeGetRequest<IApiResponse<IFleetModel>>(`fleet-models/${id}`);
};

export const updateFleetModelApi = (
  id: string,
  data: IUpdateFleetModelInput
) => {
  return authorizePatchRequest<IApiResponse<IFleetModel>>(
    `fleet-models/${id}`,
    data
  );
};

export const deleteFleetModelApi = (id: string) => {
  return authorizeDeleteRequest<IApiResponse<IFleetModel>>(
    `fleet-models/${id}`
  );
};
